import React, { useContext, useEffect, useRef, useState } from "react";
import "./Worlds.scss";
import { ThreeDeeContext } from "../../App";
import * as THREE from "three";
import { Group, Mesh, Vector3, MathUtils } from "three";
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { findMorphableMeshes } from "../../helpers/3d";
import { useCsvScenes } from "../../hooks/csv-scenes";
import { delimiter } from "../../pages/Exporter/Exporter";

interface IProps {
    setModelLoaded: (loaded: boolean) => void;
    customProps: {scene?: string, csvEmissionData?: string, csvZeroEmissionData?: string};
    setProgress: (progress: number) => void;
}

interface IObjects {
    morphableMeshes?: {emission: Mesh[], zeroEmission: Mesh[]};
    emissionWorld?: Group;
    zeroEmissionWorld?: Group;
}

export function Worlds({ setModelLoaded, customProps, setProgress }: IProps) {
    const emissionState = useCsvScenes(customProps.csvEmissionData ?? '/resources/csv/endpoints.csv');
    // const zeroEmissionState = useCsvScenes(customProps.csvZeroEmissionData ?? '/resources/csv/zero-endpoints.csv');
    // console.log({a: customProps});
    const canvasRef = useRef(null);
    const state = useContext(ThreeDeeContext);
    const [objects, setObjects] = useState<IObjects>({});

    const setEmissionModel = emissionState.setModel;
    // const applyEmissionState = emissionState.apply;
    const setEmissionAnimations = emissionState.setAnimations;
    // const setZeroEmissionModel = zeroEmissionState.setModel;
    // const applyZeroEmissionState = zeroEmissionState.apply;
    // const setZeroEmissionAnimations = zeroEmissionState.setAnimations;
    const setEmissionSceneIndex = emissionState.setActiveSceneIndex;
    // const setZeroEmissionSceneIndex = zeroEmissionState.setActiveSceneIndex;

    const givenEmissionState = state.emission;
    const givenSliderValue = state.sliderValue;

    useEffect(() => {
        const canvas = canvasRef.current as any as HTMLCanvasElement;
        if (canvas) {
            const ios = () => {
                return [
                        'iPad Simulator',
                        'iPhone Simulator',
                        'iPod Simulator',
                        'iPad',
                        'iPhone',
                        'iPod'
                    ].includes(navigator.platform)
                    // iPad on iOS 13 detection
                    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
            }
            // const context = canvas.getContext('2d');
            // context?.clearRect(0, 0, canvas.width, canvas.height);

            /**
             * Models
             */
            const gltfLoader = new GLTFLoader();
            const ext = ios() ? 'glb' : 'gltf';
            gltfLoader.load(
                customProps.scene ?? `/models/holo-planet/holo_planet_14.${ext}`,
                (gltf) =>
                {
                    const worlds = new THREE.Group();
                    scene.add(worlds);

                    // gltf.scene.castShadow = true;
                    // console.log({test: gltf.scene.children[3].children[6]});
                    for(let i = 0; i <= 5; i++) {
                        // gltf.scene.children[3].children[i].castShadow = true;
                    }

                    setEmissionAnimations(gltf.animations.filter(animation => animation.name.split(delimiter)[0] === 'Morph'));
                    // setZeroEmissionAnimations(gltf.animations.filter(animation => animation.name.split(delimiter)[0] === 'Morph'));



                    const morphableMeshes: {emission: Mesh[], zeroEmission: Mesh[]} = {
                        emission: [],
                        zeroEmission: [],
                    };
                    const world = gltf.scene;
                    const group = new THREE.Group();
                    worlds.add(group);
                    group.add(world);

                    setEmissionModel(world);
                    // setZeroEmissionModel(world);

                    world.position.y = 0;
                    world.position.x = 0;

                    const axis = new Vector3(1.5, 0, 1.5).normalize();
                    group.rotateOnAxis(axis, MathUtils.degToRad(25));

                    const mixer = new THREE.AnimationMixer(world);

                    gltf.animations.forEach((animation) => {
                        if (!animation.name.toLowerCase().includes('morph')) {
                            mixer.clipAction(animation).play();
                        }
                    });
                    morphableMeshes.emission = findMorphableMeshes(world);
                    morphableMeshes.zeroEmission = findMorphableMeshes(world);

                    const clock = new THREE.Clock();
                    let previousTime = 0;
                    const animate = () => {
                        requestAnimationFrame(animate);
                        const elapsedTime = clock.getElapsedTime();
                        const deltaTime = elapsedTime - previousTime;
                        previousTime = elapsedTime;
                        if(mixer) mixer.update(deltaTime);

                        // world.rotation.y += 0.01;
                    }
                    animate();

                    // const emissionWorld = gltf.scene.clone(true);
                    // const zeroEmissionWorld = emissionWorld;
                    //
                    // const morphableMeshes: {emission: Mesh[], zeroEmission: Mesh[]} = {
                    //     emission: [],
                    //     zeroEmission: [],
                    // };
                    // [emissionWorld, zeroEmissionWorld].forEach((world, index) => {
                    //     const worldType = index === 0 ? 'emission': 'zeroEmission';
                    //     const group = new THREE.Group();
                    //     worlds.add(group);
                    //     group.add(world);
                    //
                    //     if (worldType === 'emission') {
                    //         setEmissionModel(world);
                    //     }
                    //     if (worldType === 'zeroEmission') {
                    //         setZeroEmissionModel(world);
                    //     }
                    //
                    //     world.position.y = 0;
                    //     world.position.x = 0;
                    //
                    //     const axis = new Vector3(1.5, 0, 1.5).normalize();
                    //     group.rotateOnAxis(axis, MathUtils.degToRad(25));
                    //
                    //     const mixer = new THREE.AnimationMixer(world);
                    //
                    //     gltf.animations.forEach((animation) => {
                    //         if (!animation.name.toLowerCase().includes('morph')) {
                    //             mixer.clipAction(animation).play();
                    //         }
                    //     });
                    //     morphableMeshes[worldType] = findMorphableMeshes(world);
                    //
                    //     const clock = new THREE.Clock();
                    //     let previousTime = 0;
                    //     const animate = () => {
                    //         requestAnimationFrame(animate);
                    //         const elapsedTime = clock.getElapsedTime();
                    //         const deltaTime = elapsedTime - previousTime;
                    //         previousTime = elapsedTime;
                    //         if(mixer) mixer.update(deltaTime);
                    //
                    //         // world.rotation.y += 0.01;
                    //     }
                    //     animate();
                    // });

                    setObjects({emissionWorld: world, zeroEmissionWorld: world, morphableMeshes});
                    setModelLoaded(true);
                },
                (xhr) => {
                    setProgress(xhr.loaded / (xhr.total || 182047724) * 100);
                }
            )



            const parent = canvas.parentElement as any as HTMLDivElement;
            // Setup
            // === THREE.JS CODE START ===
            const scene = new THREE.Scene();


            // const axesHelper = new THREE.AxesHelper( 50 );
            // scene.add( axesHelper );

            const camera = new THREE.PerspectiveCamera( 75, parent.clientWidth / parent.clientHeight, 1, 1000 );
            const renderer = new THREE.WebGLRenderer({ canvas, alpha: true, antialias: !(window.devicePixelRatio > 1), powerPreference: 'high-performance' });
            renderer.setPixelRatio(window.devicePixelRatio);
            renderer.setSize( parent.clientWidth, parent.clientHeight );
            renderer.shadowMap.enabled = true


            // Ambient light
            const ambientLight = new THREE.AmbientLight()
            ambientLight.color = new THREE.Color(0xffffff)
            ambientLight.intensity = 0.5
            scene.add(ambientLight)


            // Directional light
            const directionalLight = new THREE.DirectionalLight(0xFFFFFF, 2);
            // directionalLight.castShadow = true;
            directionalLight.position.set(2, 2.9, 4);
            // directionalLight.shadow.camera.near = 1
            // directionalLight.shadow.camera.far = 10
            // directionalLight.shadow.bias = -0.01;
            // directionalLight.shadow.radius = 10;
            scene.add(directionalLight);

            camera.position.y = 0;

            // const controls = new OrbitControls(camera, canvas)
            // controls.enableDamping = true

            const light = new THREE.HemisphereLight( 0xffffbb, 0x080820, 1 ); scene.add( light );

            // Set the shadowMaterial
            const shadowMaterial = new THREE.ShadowMaterial();
            shadowMaterial.opacity = 0.25;

            // const visibleMaterial = new MeshDepthMaterial();


            // Holobox floor
            const floor = new THREE.Mesh(
                new THREE.BoxGeometry(30, 100, 5, 50, 1, 50),
                shadowMaterial
            );
            floor.position.y = -53;
            floor.position.z = 0;
            floor.castShadow = true;
            floor.receiveShadow = true;
            scene.add(floor);

            // // Holobox wall
            // // const mesh = new THREE.Mesh(
            // //     new THREE.BoxGeometry(1, 1, 1, 5, 5, 5),
            // //     new THREE.MeshBasicMaterial({ color: 0xff0000 })
            // // );
            // // mesh.castShadow = true;
            // // scene.add(mesh);
            const wall = new THREE.Mesh(
                new THREE.BoxGeometry(30, 50, 100, 50, 50, 1),
                shadowMaterial
                // new MeshDepthMaterial({
                //     opacity: 1,
                //     visible: true,
                //     side: THREE.FrontSide,
                // })
            );
            wall.position.y = 22;
            wall.position.z = -51.5;
            wall.castShadow = true;
            wall.receiveShadow = true;
            scene.add(wall);

            // Top light
            const topLight = new THREE.DirectionalLight(0xFFFFFF, 0);
            topLight.position.set(0, 3, 0);
            topLight.lookAt(floor.position);
            // topLight.castShadow = true;
            // topLight.shadow.camera.near = 1
            // topLight.shadow.camera.far = 6
            // topLight.shadow.bias = -0.01;
            // topLight.shadow.radius = 10;
            scene.add(topLight);

            const animate = function () {
                requestAnimationFrame( animate );

                // controls.update();

                renderer.render( scene, camera );
            };
            animate();




            const onWindowResize = () => {

                camera.position.z = window.innerWidth > window.innerHeight ? 3 : 5;
                camera.aspect = window.innerWidth / window.innerHeight;
                camera.updateProjectionMatrix();

                renderer.setSize( window.innerWidth, window.innerHeight );

            }
            onWindowResize();

            window.addEventListener( 'resize', onWindowResize, false );

            return () => {
                window.removeEventListener( 'resize', onWindowResize);
            }
        }
    }, [canvasRef, customProps.scene, setEmissionModel, setEmissionAnimations, setModelLoaded, setProgress]);



    useEffect(() => {
        const { morphableMeshes } = objects;

        if (!morphableMeshes) {
            return;
        }

        const timeout = setTimeout(() => {
            const season = givenSliderValue % 2 ? 'winter' : 'summer';
            // setZeroEmissionSceneIndex(season === 'summer' ? 0 : 1);
            if (givenEmissionState) {
                setEmissionSceneIndex(givenSliderValue)
            } else {
                setEmissionSceneIndex(season === 'summer' ? 0 : 1)
            }
            // setEmissionSceneIndex(givenSliderValue);
            // setZeroEmissionSceneIndex(givenSliderValue);
        }, 500);
        return () => {
            clearTimeout(timeout);
        }
    }, [givenEmissionState, givenSliderValue, objects, setEmissionSceneIndex]);

    // useEffect(() => {
    //     const { morphableMeshes } = objects;
    //
    //     if (!morphableMeshes) {
    //         return;
    //     }
    //
    //     const timeout = setTimeout(() => {
    //         console.log('applying emission state');
    //         if (givenEmissionState) {
    //             applyEmissionState();
    //         } else {
    //             applyZeroEmissionState();
    //         }
    //     }, 500);
    //     return () => {
    //         clearTimeout(timeout);
    //     }
    // }, [givenEmissionState, objects, applyEmissionState, applyZeroEmissionState]);


    return (
        <div className="cube-wrapper">
            <canvas ref={canvasRef} />
        </div>
    )
}
// function getObjectSize(object: Mesh | Group | Object3D) {
//     const size = new THREE.Vector3(0, 0, 0);
//     if (!(object as any)?.geometry) {
//         const group = object as Group;
//
//         group.children.forEach((child: any) => {
//             const childSize = getObjectSize(child as Group);
//             if (childSize.x > size.x) {
//                 size.x = childSize.x;
//             }
//             if (childSize.y > size.y) {
//                 size.y = childSize.y;
//             }
//             if (childSize.z > size.z) {
//                 size.z = childSize.z;
//             }
//         })
//     } else {
//         (object as Mesh).geometry.computeBoundingBox();
//         (object as Mesh).geometry.boundingBox?.getSize(size);
//     }
//     return size;
// }
//
//
// const morphMap = {
//     1: { // 2020
//         snow: 0,
//         cow1: 1,
//         cow2: 1,
//         cow3: 1,
//     },
//     2: { // 2025
//         snow: 0.75,
//         cow1: 1,
//         cow2: 1,
//         cow3: 0,
//     },
//     3: { // 2030
//         snow: 0,
//         cow1: 1,
//         cow2: 1,
//         cow3: 1,
//     },
//     4: { // 2035
//         snow: 0.95,
//         cow1: 1,
//         cow2: 0,
//         cow3: 0,
//     },
//     5: { // 2040
//         snow: 0,
//         cow1: 1,
//         cow2: 1,
//         cow3: 0,
//     },
// }
